import { THEMES } from './themes'
import { PROVIDERS } from './providers'

export const TENANT_HOST_RULES = [
  { hosts: ['legal-data-hub'], theme: THEMES.LDA_LIGHT, provider: PROVIDERS.MICROSOFT },
  { hosts: ['mohr-siebeck'], theme: THEMES.MOHR_SIEBECK, provider: PROVIDERS.MS },
  { hosts: ['rehm'], theme: THEMES.REHM, provider: PROVIDERS.REHM },
  { hosts: ['linde'], theme: THEMES.LINDE, provider: PROVIDERS.LINDE },
  { hosts: ['staempfli'], theme: THEMES.STAEMPFLI, provider: PROVIDERS.STAEMPFLI },
  { hosts: ['erich-schmidt'], theme: THEMES.ERICH_SCHMIDT, provider: PROVIDERS.ERICH_SCHMIDT },
  {
    hosts: ['bürokratie-radar', 'buerokratie-radar'],
    theme: THEMES.NKR,
    provider: PROVIDERS.NKR,
  },
]

export const DEFAULT_PROVIDER = PROVIDERS.OTTO_SCHMIDT

export function detectTenantFromHost(hostname) {
  const host = hostname || ''
  return TENANT_HOST_RULES.find((rule) => rule.hosts.some((h) => host.includes(h)))
}

export function detectThemeFromHost(hostname) {
  return detectTenantFromHost(hostname)?.theme
}

export function detectProviderFromHost(hostname) {
  return detectTenantFromHost(hostname)?.provider || DEFAULT_PROVIDER
}
